import { IsNumber } from 'class-validator';

export class Dimension {
  @IsNumber()
  width: number;
  @IsNumber()
  height: number;
}
